<script lang="ts" setup>
import type { TimelineItem } from '~/components/ContentBlock/VideosTimeline.vue'

interface Props {
  item: TimelineItem
}

const props = defineProps<Props>()

const { posterUrl } = useYouTubeVideo(props.item.youtubeEmbedUrl)

const imageUrl = computed<string | undefined>(() => props.item.image?.src || posterUrl.value)
</script>

<template>
  <button class="timeline__thumbnails-item">
    <img
      :src="imageUrl"
      :alt="item.image?.alt || item?.title"
      class="timeline__thumbnails-image"
    >
    <div
      v-if="item.title && item.description"
      class="timeline__thumbnails-meta"
    >
      <h3 v-if="item.title">
        {{ item.title }}
      </h3>
      <p v-if="item.description">
        {{ item.description }}
      </p>
    </div>
  </button>
</template>
